import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// import './index.css'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


import App from './App.tsx'
import { TenantContextProvider } from './services';

createRoot(document.getElementById('root')!).render(
    <>
        <TenantContextProvider>
            <App />
        </TenantContextProvider>
    </>,
)
